import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["href", "data-game-id", "data-game-code"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]

import { computed, onMounted, Ref, useTemplateRef } from "vue";
import { GamesCardGame } from "../models/game-card-game";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { useGameEffects } from "../composables/use-game-effects";
import WebpVideo from "@sazka/design-system/src/video/webp-video.vue";
import JackpotIcon from "./jackpot-icon.vue";

export interface GameCardGameExpose {
    rootElement: Ref<HTMLElement>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'games-card-game',
  props: {
    game: {},
    loading: { type: Boolean },
    variant: { default: "default" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const isDesktop = useBreakpoints("sm2");
const isLowPerformance = environment.isLowPerformanceDevice;
const gameCard = useTemplateRef<HTMLElement>("gameCard");
const variantClass = props.variant ? "games-card-game--" + props.variant : null;

__expose<GameCardGameExpose>({
    rootElement: gameCard,
});

const image = computed(() => {
    return props.variant == "default" && props.game?.teaserImageVerticalUrl
        ? props.game?.teaserImageVerticalUrl
        : props.game?.teaserImageUrl;
});

const showCard = computed(() => !props.loading && props.game);

onMounted(async () => {
    if (isDesktop.value) {
        const { setupEffects } = useGameEffects([gameCard.value], () => isDesktop.value);
        setupEffects();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    ref_key: "gameCard",
    ref: gameCard,
    href: _ctx.game?.url?.relative,
    "data-game-id": _ctx.game?.externalSystemId,
    "data-game-code": _ctx.game?.codeName,
    class: _normalizeClass(["games-card-game", [_unref(variantClass), { 'game-launcher': !_ctx.loading }, { 'games-card-game--skeleton': _ctx.loading }]]),
    style: _normalizeStyle(`--game-gradient-color: ${_ctx.game?.gradientColor ?? '#000'}`)
  }, [
    (showCard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (image.value)
            ? (_openBlock(), _createBlock(WebpVideo, {
                key: 0,
                src: image.value,
                alt: `${props.game?.name} - obrázek`,
                "css-class": "games-card-game__img",
                "loop-video": true,
                width: 124,
                height: 140,
                "is-video-allowed": !_unref(isLowPerformance)
              }, null, 8, ["src", "alt", "is-video-allowed"]))
            : _createCommentVNode("", true),
          (_ctx.game.jackpotGuid)
            ? (_openBlock(), _createBlock(JackpotIcon, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("h3", {
            class: "games-card-game__text",
            innerHTML: _ctx.game.name
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})